import { FC } from 'react';
import { BsGeoFill } from 'react-icons/bs';

import { Anchor, Group } from '@mantine/core';

import { CompanyProfile } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';
import { GEOHelpers } from 'helpers/GEOHelpers';

const HeaderLocation: FC<{ company: CompanyProfile }> = ({ company }) => {
    const locationSummary = CompanyHelpers.summarizeLocations(company.locations);

    return locationSummary ? (
        <Group gap={6} wrap="nowrap">
            <BsGeoFill size="1em" style={{ flexShrink: 0 }} />
            <Anchor
                truncate
                miw={0}
                href={GEOHelpers.getGoogleMapsSearchURL(`${company.name}, ${locationSummary}`)}
                target="_blank"
                c="inherit"
                inherit
            >
                {locationSummary}
            </Anchor>
        </Group>
    ) : null;
};

export { HeaderLocation };
